import {
  BasketballTeamSlice,
  userActiveBasketballCoachTeamId,
} from '@hefe/store';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import MessagesAppComponent from '../../../messages/components/messages-app/messages-app.component';

export default function TeamMessagesPage() {
  const loading = useSelector(
    BasketballTeamSlice.basketballTeamMessagesLoadingSelector
  );
  const messages = useSelector(
    BasketballTeamSlice.basketballTeamMessagesSelector
  );
  const activeCoachId = useSelector(userActiveBasketballCoachTeamId);

  return (
    <MessagesAppComponent
      key={activeCoachId}
      mode="team"
      messages={messages}
      loading={loading}
      allowCompose={true}
      fetchMoreMessages={BasketballTeamSlice.fetchBasketballTeamMessages}
    />
  );
}
